// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Admin {
  background-color: black;
  color: white;
  height: 100%;
  width: 100%;
  min-width: 100vw;
  min-height: 100svh;
}

.Admin__Login {
  background-color: black;
  color: white;
  display: grid;
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  height: 40svh;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
}

.Admin__Login h1 {
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 4em;
}

.Admin__Login__Grid {
  display: grid;
  max-height: 50px;
  width: 300px;
}

.Admin_Input {
  background-color: black;
  border: 2px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 2em;
  padding-left: 0.5em;
  text-transform: lowercase;
  font-weight: bold;
  font-size: 18px;
}

.Admin_Input:hover {
  border: 2px solid red;
  color: white;
}

.Admin_Input:focus {
  border: 2px solid red;
  color: white;
}

.Admin_Button {
  background-color: black;
  border: 2px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
  padding: 0.5em 0.5em 0.5em 0.5em;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 2em;
  text-transform: lowercase;
  font-weight: bold;
  font-size: 18px;
}

.Admin__Main__Grid {
  display: grid;
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
}

.Admin__Main__Grid__Child {
  height: 100%;
  margin-bottom: 8em;
}

.Admin__Section {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  max-width: 100%;
  gap: 1em;
  justify-content: left;
  padding: 0;
  margin: 0;
  margin-bottom: 2em;
}

.Admin__Section__Title {
  font-weight: bolder;
  font-size: 18px;
  align-self: center;
}

.Admin__Section__New {
  font-weight: bold;
  font-size: 18px;
  background-color: black;
  border: 2px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
  padding: 0.5em 0.5em 0.5em 0.5em;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  justify-self: end;
  align-self: flex-start;
}

.Admin__Section__New:hover {
  border: 2px solid red;
  color: white;
}

.Admin__Section__New:focus {
  border: 2px solid red;
  color: white;
}

.Admin__Projects__Grid {
  display: grid;
  max-width: 100%;
  grid-template-columns: repeat(6, minmax(150px, 1fr));
  gap: 1em;
  justify-content: left;
  padding: 0;
  margin: 0;
}

.Admin__Project__Item {
  border: solid rgba(255, 255, 255, 0.6) 2px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-content: center;
}

.Admin__Project__Item:hover {
  border: solid red 2px;
}

.Admin__Project__Item__Thumbnail {
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  text-align: left;
  color: rgba(255, 255, 255, 0.6);
}

.Admin__Project__Item__Title {
  width: 85%;
  max-height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  grid-column: 1 / 2;
  background-color: rgba(0, 0, 0, 1);
  padding: 0.5em 0em 0.5em 0.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Admin__Project__Item__Img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  grid-column: 1 / 2;
}

.Admin__Project__Item p {
  font-size: 14px;
}

.Admin__Project__Item__Icons {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 1);
  padding: 0.5em 0em 0.5em 0.5em;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  align-items: center;
}

.Admin__Project__Item__Action {
  cursor: pointer;
  align-self: center;
  padding: 0 0.5em 0 0em;
}

.Admin__Project__Item__Action:hover {
  color: red;
}

.Admin__Project__Item__Action:focus {
  border: none;
}

.Admin__Award__Item {
  border: solid rgba(255, 255, 255, 0.6) 2px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-content: center;
}

.Admin__Award__Item:hover {
  border: solid red 2px;
}

.Admin__Award__Item__Thumbnail {
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  text-align: left;
  color: rgba(255, 255, 255, 0.6);
}

.Admin__Award__Item__Title {
  width: 85%;
  max-height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  grid-column: 1 / 2;
  background-color: rgba(0, 0, 0, 1);
  padding: 0.5em 0em 0.5em 0.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Admin__Award__Item p {
  font-size: 14px;
}

.Admin__Award__Item__Icons {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 1);
  padding: 0.5em 0em 0.5em 0.5em;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  align-items: center;
}

.Admin__Award__Item__Action {
  cursor: pointer;
  align-self: center;
  padding: 0 0.5em 0 0em;
}

.Admin__Award__Item__Action:hover {
  color: red;
}

.Admin__Award__Item__Action:focus {
  border: none;
}

.Admin__New__Form input {
  background-color: black;
  border: solid rgba(255, 255, 255, 0.6) 2px;
  color: rgba(255, 255, 255, 0.6);
}

.sidenav {
  width: clamp(240px, 10%, 10%);
  background: rgba(255, 255, 255, 0.6);
  height: 100%;
  padding: 1em 30px;
  transition: all 1s;
  color: black;
  position: fixed;
  top: 0;
  z-index: 100000;
}

.sidenav h1 {
  padding: 0;
  margin-bottom: 1em;
  font-weight: bold;
  text-decoration: underline;
}

.sidenav ul {
  padding: 0;
}

.sidenav ul li {
  list-style-type: none;
}

.sidenav ul li a {
  color: black;
  text-decoration: none;
  font-size: 16px;
  display: block;
  padding: 10px 15px;
  border-radius: 6px;
}

.sidenav ul li a:hover,
.sidenav ul li a:active {
  background: rgba(255, 255, 255, 0.6);
}

/* NEW TEAM */

.Admin__NewTeam__Grid {
  display: grid;
  width: 70vw;
  grid-template-columns: 1fr;
  justify-content: left;
  align-items: center;
  padding: 0;
  margin: 0;
}

.Admin__Team__New {
  display: grid;
  width: 50%;
  grid-template-columns: 1fr;
  justify-content: left;
  align-items: center;
  padding: 0;
  margin: 0;
}

.New__Project__Select {
  background-color: black;
  border: solid rgba(255, 255, 255, 0.6) 2px;
  color: rgba(255, 255, 255, 0.6);
  width: 100%;
}

.Admin_Input {
  background-color: black;
  border: 2px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 2em;
  padding-left: 0.5em;
  text-transform: lowercase;
  font-weight: bold;
  font-size: 18px;
}

.Admin_Input:hover {
  border: 2px solid red;
  color: white;
}

.Admin_Input:focus {
  border: 2px solid red;
  color: white;
}

.Admin_Button {
  background-color: black;
  border: 2px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
  padding: 0.5em 0.5em 0.5em 0.5em;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 2em;
  text-transform: lowercase;
  font-weight: bold;
  font-size: 18px;
}

.Admin__New__Form {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 25px;
}

.Admin__Projects__New {
  margin-top: 12.5svh;
}

.Admin__Projects__New h1 {
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 4em;
}

.New_Admin_Input:hover {
  border: 2px solid red;
  color: white;
}

.New_Admin_Input:focus {
  border: 2px solid red;
  color: white;
}

.New_Form_Input p {
  margin-bottom: 25px;
  font-weight: bolder;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
}

.New_Admin_Input {
  background-color: black;
  border: 2px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0;
  padding-left: 0.5em;
  font-weight: bold;
  font-size: 18px;
  max-height: 50px;
  width: 100%;
}

.New_Admin_Input__text {
  background-color: black;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0;
  padding-left: 0;
  font-weight: bold;
  font-size: 18px;
  height: 200px;
  width: 100%;
}

#Title_PT {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

#Title_EN {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

#Type {
  grid-column: 1 / 2;
  grid-row: 3 / 4;
}

#Capa {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

#Destaque {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

#Medalhas {
  grid-column: 2 / 3;
  grid-row: 3 / 4;
}

#Content {
  grid-column: 2 / 3;
  grid-row: 4 / 5;
}

#Quote_title_PT {
  grid-column: 2 / 3;
  grid-row: 5 / 6;
}

#Quote_body_PT {
  grid-column: 2 / 3;
  grid-row: 6 / 7;
}

#Quote_title_EN {
  grid-column: 2 / 3;
  grid-row: 7 / 8;
}

#Quote_body_EN {
  grid-column: 2 / 3;
  grid-row: 8 / 9;
}

#Client_PT {
  grid-column: 3 / 4;
  grid-row: 1 / 2;
}

#Client_EN {
  grid-column: 3 / 4 !important;
  grid-row: 2 / 3;
}

#Year {
  grid-column: 3 / 4;
  grid-row: 3 / 4;
}

#Equipa_PT {
  grid-column: 3 / 4;
  grid-row: 4 / 5;
}

#Equipa_EN {
  grid-column: 3 / 4;
  grid-row: 5 / 6;
}

#Awards_PT {
  grid-column: 3 / 4;
  grid-row: 6 / 8;
}

#Awards_EN {
  grid-column: 3 / 4;
  grid-row: 8 / 10;
}

#Nome {
  grid-column: 1 /2;
  grid-row: 1 / 2;
}

#Cargo {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

#Bio_PT {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

#Bio_EN {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

#Avatar {
  grid-column: 3 /4;
  grid-row: 1 / 2;
}

#Type_PT {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

#Type_EN {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

#Year_Awards {
  grid-column: 2 / 3;
  grid-row: 3 / 4;
}

#Year_Awards2 {
  grid-column: 3 / 4;
  grid-row: 1 / 2;
}

#Assiggnor_PT {
  grid-column: 3 /4;
  grid-row: 1 / 2;
}

#Assiggnor_EN {
  grid-column: 3 /4;
  grid-row: 2 / 3;
}
`, "",{"version":3,"sources":["webpack://./src/css/Admin.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,eAAe;EACf,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oDAAoD;EACpD,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EAEpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".Admin {\r\n  background-color: black;\r\n  color: white;\r\n  height: 100%;\r\n  width: 100%;\r\n  min-width: 100vw;\r\n  min-height: 100svh;\r\n}\r\n\r\n.Admin__Login {\r\n  background-color: black;\r\n  color: white;\r\n  display: grid;\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  height: 40svh;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n}\r\n\r\n.Admin__Login h1 {\r\n  font-weight: bolder;\r\n  font-size: 18px;\r\n  margin-bottom: 4em;\r\n}\r\n\r\n.Admin__Login__Grid {\r\n  display: grid;\r\n  max-height: 50px;\r\n  width: 300px;\r\n}\r\n\r\n.Admin_Input {\r\n  background-color: black;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n  color: rgba(255, 255, 255, 0.6);\r\n  margin-bottom: 2em;\r\n  padding-left: 0.5em;\r\n  text-transform: lowercase;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n}\r\n\r\n.Admin_Input:hover {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.Admin_Input:focus {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.Admin_Button {\r\n  background-color: black;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n  color: rgba(255, 255, 255, 0.6);\r\n  padding: 0.5em 0.5em 0.5em 0.5em;\r\n  text-align: center;\r\n  width: fit-content;\r\n  margin-top: 2em;\r\n  text-transform: lowercase;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n}\r\n\r\n.Admin__Main__Grid {\r\n  display: grid;\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n}\r\n\r\n.Admin__Main__Grid__Child {\r\n  height: 100%;\r\n  margin-bottom: 8em;\r\n}\r\n\r\n.Admin__Section {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n  max-width: 100%;\r\n  gap: 1em;\r\n  justify-content: left;\r\n  padding: 0;\r\n  margin: 0;\r\n  margin-bottom: 2em;\r\n}\r\n\r\n.Admin__Section__Title {\r\n  font-weight: bolder;\r\n  font-size: 18px;\r\n  align-self: center;\r\n}\r\n\r\n.Admin__Section__New {\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  background-color: black;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n  color: rgba(255, 255, 255, 0.6);\r\n  padding: 0.5em 0.5em 0.5em 0.5em;\r\n  text-align: center;\r\n  width: fit-content;\r\n  justify-self: end;\r\n  align-self: flex-start;\r\n}\r\n\r\n.Admin__Section__New:hover {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.Admin__Section__New:focus {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.Admin__Projects__Grid {\r\n  display: grid;\r\n  max-width: 100%;\r\n  grid-template-columns: repeat(6, minmax(150px, 1fr));\r\n  gap: 1em;\r\n  justify-content: left;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.Admin__Project__Item {\r\n  border: solid rgba(255, 255, 255, 0.6) 2px;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.Admin__Project__Item:hover {\r\n  border: solid red 2px;\r\n}\r\n\r\n.Admin__Project__Item__Thumbnail {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  position: relative;\r\n  text-align: left;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.Admin__Project__Item__Title {\r\n  width: 85%;\r\n  max-height: 50px;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 100;\r\n  grid-column: 1 / 2;\r\n  background-color: rgba(0, 0, 0, 1);\r\n  padding: 0.5em 0em 0.5em 0.5em;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.Admin__Project__Item__Img {\r\n  width: 100%;\r\n  aspect-ratio: 1 / 1;\r\n  object-fit: cover;\r\n  grid-column: 1 / 2;\r\n}\r\n\r\n.Admin__Project__Item p {\r\n  font-size: 14px;\r\n}\r\n\r\n.Admin__Project__Item__Icons {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 1000;\r\n  background-color: rgba(0, 0, 0, 1);\r\n  padding: 0.5em 0em 0.5em 0.5em;\r\n  height: 100%;\r\n  display: grid;\r\n  grid-template-rows: 1fr 1fr 1fr 1fr;\r\n  align-items: center;\r\n}\r\n\r\n.Admin__Project__Item__Action {\r\n  cursor: pointer;\r\n  align-self: center;\r\n  padding: 0 0.5em 0 0em;\r\n}\r\n\r\n.Admin__Project__Item__Action:hover {\r\n  color: red;\r\n}\r\n\r\n.Admin__Project__Item__Action:focus {\r\n  border: none;\r\n}\r\n\r\n.Admin__Award__Item {\r\n  border: solid rgba(255, 255, 255, 0.6) 2px;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.Admin__Award__Item:hover {\r\n  border: solid red 2px;\r\n}\r\n\r\n.Admin__Award__Item__Thumbnail {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  position: relative;\r\n  text-align: left;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.Admin__Award__Item__Title {\r\n  width: 85%;\r\n  max-height: 50px;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 100;\r\n  grid-column: 1 / 2;\r\n  background-color: rgba(0, 0, 0, 1);\r\n  padding: 0.5em 0em 0.5em 0.5em;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.Admin__Award__Item p {\r\n  font-size: 14px;\r\n}\r\n\r\n.Admin__Award__Item__Icons {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 1000;\r\n  background-color: rgba(0, 0, 0, 1);\r\n  padding: 0.5em 0em 0.5em 0.5em;\r\n  height: 100%;\r\n  display: grid;\r\n  grid-template-rows: 1fr 1fr 1fr;\r\n  align-items: center;\r\n}\r\n\r\n.Admin__Award__Item__Action {\r\n  cursor: pointer;\r\n  align-self: center;\r\n  padding: 0 0.5em 0 0em;\r\n}\r\n\r\n.Admin__Award__Item__Action:hover {\r\n  color: red;\r\n}\r\n\r\n.Admin__Award__Item__Action:focus {\r\n  border: none;\r\n}\r\n\r\n.Admin__New__Form input {\r\n  background-color: black;\r\n  border: solid rgba(255, 255, 255, 0.6) 2px;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.sidenav {\r\n  width: clamp(240px, 10%, 10%);\r\n  background: rgba(255, 255, 255, 0.6);\r\n  position: fixed;\r\n  height: 100%;\r\n  padding: 1em 30px;\r\n  transition: all 1s;\r\n  color: black;\r\n  position: fixed;\r\n  top: 0;\r\n  z-index: 100000;\r\n}\r\n\r\n.sidenav h1 {\r\n  padding: 0;\r\n  margin-bottom: 1em;\r\n  font-weight: bold;\r\n  text-decoration: underline;\r\n}\r\n\r\n.sidenav ul {\r\n  padding: 0;\r\n}\r\n\r\n.sidenav ul li {\r\n  list-style-type: none;\r\n}\r\n\r\n.sidenav ul li a {\r\n  color: black;\r\n  text-decoration: none;\r\n  font-size: 16px;\r\n  display: block;\r\n  padding: 10px 15px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.sidenav ul li a:hover,\r\n.sidenav ul li a:active {\r\n  background: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n/* NEW TEAM */\r\n\r\n.Admin__NewTeam__Grid {\r\n  display: grid;\r\n  width: 70vw;\r\n  grid-template-columns: 1fr;\r\n  justify-content: left;\r\n  align-items: center;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.Admin__Team__New {\r\n  display: grid;\r\n  width: 50%;\r\n  grid-template-columns: 1fr;\r\n  justify-content: left;\r\n  align-items: center;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.New__Project__Select {\r\n  background-color: black;\r\n  border: solid rgba(255, 255, 255, 0.6) 2px;\r\n  color: rgba(255, 255, 255, 0.6);\r\n  width: 100%;\r\n}\r\n\r\n.Admin_Input {\r\n  background-color: black;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n  color: rgba(255, 255, 255, 0.6);\r\n  margin-bottom: 2em;\r\n  padding-left: 0.5em;\r\n  text-transform: lowercase;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n}\r\n\r\n.Admin_Input:hover {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.Admin_Input:focus {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.Admin_Button {\r\n  background-color: black;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n  color: rgba(255, 255, 255, 0.6);\r\n  padding: 0.5em 0.5em 0.5em 0.5em;\r\n  text-align: center;\r\n  width: fit-content;\r\n  margin-top: 2em;\r\n  text-transform: lowercase;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n}\r\n\r\n.Admin__New__Form {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  gap: 25px;\r\n}\r\n\r\n.Admin__Projects__New {\r\n  margin-top: 12.5svh;\r\n}\r\n\r\n.Admin__Projects__New h1 {\r\n  font-weight: bolder;\r\n  font-size: 18px;\r\n  margin-bottom: 4em;\r\n}\r\n\r\n.New_Admin_Input:hover {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.New_Admin_Input:focus {\r\n  border: 2px solid red;\r\n  color: white;\r\n}\r\n\r\n.New_Form_Input p {\r\n  margin-bottom: 25px;\r\n  font-weight: bolder;\r\n  font-size: 18px;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.New_Admin_Input {\r\n  background-color: black;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n  color: rgba(255, 255, 255, 0.6);\r\n  margin-bottom: 0;\r\n  padding-left: 0.5em;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  max-height: 50px;\r\n  width: 100%;\r\n}\r\n\r\n.New_Admin_Input__text {\r\n  background-color: black;\r\n  color: rgba(255, 255, 255, 0.6);\r\n  margin-bottom: 0;\r\n  padding-left: 0;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  height: 200px;\r\n  width: 100%;\r\n}\r\n\r\n#Title_PT {\r\n  grid-column: 1 / 2;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Title_EN {\r\n  grid-column: 1 / 2;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n#Type {\r\n  grid-column: 1 / 2;\r\n  grid-row: 3 / 4;\r\n}\r\n\r\n#Capa {\r\n  grid-column: 2 / 3;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Destaque {\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n#Medalhas {\r\n  grid-column: 2 / 3;\r\n  grid-row: 3 / 4;\r\n}\r\n\r\n#Content {\r\n  grid-column: 2 / 3;\r\n  grid-row: 4 / 5;\r\n}\r\n\r\n#Quote_title_PT {\r\n  grid-column: 2 / 3;\r\n  grid-row: 5 / 6;\r\n}\r\n\r\n#Quote_body_PT {\r\n  grid-column: 2 / 3;\r\n  grid-row: 6 / 7;\r\n}\r\n\r\n#Quote_title_EN {\r\n  grid-column: 2 / 3;\r\n  grid-row: 7 / 8;\r\n}\r\n\r\n#Quote_body_EN {\r\n  grid-column: 2 / 3;\r\n  grid-row: 8 / 9;\r\n}\r\n\r\n#Client_PT {\r\n  grid-column: 3 / 4;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Client_EN {\r\n  grid-column: 3 / 4 !important;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n#Year {\r\n  grid-column: 3 / 4;\r\n  grid-row: 3 / 4;\r\n}\r\n\r\n#Equipa_PT {\r\n  grid-column: 3 / 4;\r\n  grid-row: 4 / 5;\r\n}\r\n\r\n#Equipa_EN {\r\n  grid-column: 3 / 4;\r\n  grid-row: 5 / 6;\r\n}\r\n\r\n#Awards_PT {\r\n  grid-column: 3 / 4;\r\n  grid-row: 6 / 8;\r\n}\r\n\r\n#Awards_EN {\r\n  grid-column: 3 / 4;\r\n  grid-row: 8 / 10;\r\n}\r\n\r\n#Nome {\r\n  grid-column: 1 /2;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Cargo {\r\n  grid-column: 1 / 2;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n#Bio_PT {\r\n  grid-column: 2 / 3;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Bio_EN {\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n#Avatar {\r\n  grid-column: 3 /4;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Type_PT {\r\n  grid-column: 2 / 3;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Type_EN {\r\n  grid-column: 2 / 3;\r\n  grid-row: 2 / 3;\r\n}\r\n\r\n#Year_Awards {\r\n  grid-column: 2 / 3;\r\n  grid-row: 3 / 4;\r\n}\r\n\r\n#Year_Awards2 {\r\n  grid-column: 3 / 4;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Assiggnor_PT {\r\n  grid-column: 3 /4;\r\n  grid-row: 1 / 2;\r\n}\r\n\r\n#Assiggnor_EN {\r\n  grid-column: 3 /4;\r\n  grid-row: 2 / 3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
